import { User } from '../models/user.model';

export class AddUser {
	static readonly type = '[Basic] AddUser';
	constructor(public user: User) {}
}

export class SetNewUser {
	static readonly type = '[Basic] SetNewUser';
	constructor(public user: User) {}
}

export class SetAddUserError {
	static readonly type = '[Basic] SetAddUserError';
	constructor(public addUserError: string) {}
}
